/**
 *  Returns true if the given URI is in a Disbursement Format, false otherwise.
 *  the format should be https://example.com/path?asset=assetValue&domain=domainValue&name=nameValue&signature=signatureValue
 * @param url 
 * @returns: boolean 
 */

import { DisbursementUri } from "./disbursement-uri";


export function isValidDisbursementUrlFormat(url: string): boolean {

  // Regular expression to match the URL format

  const regex = /^https:\/\/[\w.-]+(?:\/[\w.-]*)?\?asset=[\w.%+-]+&domain=[\w.%+-]+&name=[\w.%+-]+&signature=[\w.%+-]+$/;

  return regex.test(url);
}

export function parseDisbursementUrl(uri:string) {

  try {

    const url = new URL(uri);

    return new DisbursementUri(url);
    
  } catch (error) {
    
  }
 
}